import React from 'react'
import DemoVideo from './DemoVideo'


const UserCreate = () => {
  return (
    <div className='pt-2 pb-4  sm:max-w-[85%]  md:max-w-[75%] lg:max-w-[80%] max-w-[90%] flex flex-col  mx-auto mt-10 min-h-[80vh] md:mb-0 mb-20'>
      <DemoVideo />
    </div>
  )
}

export default UserCreate